import { compose, withProps } from 'recompose';

import MailchimpSettingsPage from './MailchimpSettingsPage';
import withMailchimpSettings from '../withMailchimpSettings';

export default compose(
  withMailchimpSettings,
  withProps(props => ({
    emailAddress: props.mailchimpSettings.account,
  })),
)(MailchimpSettingsPage);
